import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { VcontractsModel } from 'src/app/Model/Vcontracts.model';
import { BaseService } from '../Base/BaseService';
import { SessionStorageService } from '../sessionStorageService/session-storage.service';
import { AuthService } from '../Interceptor/auth.service';

@Injectable({
  providedIn: 'root'
})
export class ContractsService extends BaseService {

  constructor(public http: HttpClient, public lsService : SessionStorageService, authService: AuthService) {
    super(http, lsService,authService);
    this.Component = "ContractsService";
  }

  public async getContract(){
    let Contract: VcontractsModel[];
    await this.PostData("","Contract","getAllContract").then((res) => {
      if(res.head.status != 'False') {
        Contract = JSON.parse(res.body.response);
      }
    });
    return Contract;
  }

  public async getUrlTyC(data){
    let url: string;
    await this.PostData(data,"Contract","GetUrlTyC").then((res) => {
      if(res.head.status != 'False') {
        url = JSON.parse(res.body.response);
      }
    });
    return url;
  }


}
